// extracted by mini-css-extract-plugin
export default {"intro":"app-edit-price-fields_intro__RYnbQ"};